import { DateTime } from '@ksyos/date-time';
import { Box, DatePicker } from '@ksyos/design-system';
import { useState } from 'react';
import type { HandleChangeForIndex } from '@frontend/components/pages/organizations/organizationDetails/OrganizationAgbCodes';

type OrganizationAgbCodeDatesProps = {
    endDate: string | null;
    handleChangeForIndex: HandleChangeForIndex;
    index: number;
    startDate: string | null;
};

const OrganizationAgbCodeDates = ({
    endDate,
    handleChangeForIndex,
    index,
    startDate,
}: OrganizationAgbCodeDatesProps) => {
    const [startDateValue, setStartDateValue] = useState<Date | null>(transformStringToDate(startDate));
    const [endDateValue, setEndDateValue] = useState<Date | null>(transformStringToDate(endDate));

    return (
        <>
            <Box>
                <DatePicker
                    isRequired={true}
                    onBlur={() => handleBlur('startDate', startDateValue)}
                    onChange={(value) => {
                        setStartDateValue(value);
                    }}
                    value={startDateValue}
                />
            </Box>
            <Box>
                <DatePicker
                    minValue={startDate ? DateTime.from(startDate).toDate() : undefined}
                    onBlur={() => handleBlur('endDate', endDateValue)}
                    onChange={(value) => {
                        setEndDateValue(value);
                    }}
                    value={endDateValue}
                />
            </Box>
        </>
    );

    function handleBlur(key: 'startDate' | 'endDate', value: Date | null) {
        // if startdateValue is null we set it to the current date using our DateTime utility because it is required
        if (key === 'startDate' && value === null) {
            value = DateTime.now().toDate();
            setStartDateValue(value);
        }

        handleChangeForIndex(index, key, value ? DateTime.from(value).format('YYYY-MM-DD') : '');
    }

    function transformStringToDate(stringDate: string | null): Date | null {
        return stringDate ? DateTime.from(stringDate).toDate() : null;
    }
};

export default OrganizationAgbCodeDates;
